import React from 'react'

import Cookies from 'js-cookie'
import Modal from '/components/modal'

import './styles.sass'

import { getUser, signOut } from '/lib/session'

deleteParam = (key)->
  url = new URL window.location.href
  return false unless url.searchParams.get(key)?
  url.searchParams.delete key
  history.replaceState null, null, url.toString()
  true

export default \
class JoinUs extends React.Component
  constructor: ->
    super arguments...
    @state =
      user: getUser()
      modal_open: deleteParam 'join-slack'
      requested: false
      requesting: false
      request_response: null

  signOut: =>
    signOut()
    @setState user: null

  render: =>
    <Modal
      open={@state.modal_open}
      button={(toggle)=>
        @props.button?(toggle) or <a href="" onClick={toggle}>Join us on Slack</a>
      }
    >
      <div className="join">
        <h2>Join us on Slack</h2>
        {if @state.user
          if @canRequestInvite()
            @requestModal()
          else if @state.request_response
            @state.request_response
          else
            @requestSent()
        else
          <>
            <p>
              To protect the community from spam and phishing, TorontoJS requires you request an invitation with your GitHub account.
            </p>
            <p>
              Creating one is free and only takes a minute.
            </p>
            <div className="buttons">
              <a
                className="button primary"
                href="https://github.com/login/oauth/authorize?client_id=#{process.env.GITHUB_CLIENT_ID}&scope=read:user,user:email&state=join-slack"
              >
                Sign In with GitHub
              </a>
            </div>
          </>
        }
      </div>
    </Modal>

  requestModal: =>
    {avatar, name, github} = @state.user or {}
    <>
      <div className="user">
        <img className="avatar" src={avatar}/>
        <div className="info">
          <span className="name">{name}</span>
          <span className="github">@{github}</span>
        </div>
      </div>
      <div className="buttons">
        <button className="button primary" type="button" disabled={@state.requesting} onClick={=> @requestInvite()}>
          Request Invitation
        </button>
        <button className="button" type="button" onClick={@signOut}>
          Sign Out
        </button>
      </div>
    </>

  requestSent: =>
    <p>
      Your request has been submitted!
      <br/>
      <br/>
      Approvals or rejections can take up to a week but typically 1-2 days
    </p>

  canRequestInvite: =>
    return false unless github = @state.user?.github
    return false if Cookies.get "invitation_requested_at_#{github}"
    not @state.requested

  requestInvite: (evt)=>
    evt?.preventDefault?()
    return false if @state.requesting or @state.requested
    return false unless github = @state.user?.github
    @setState requesting: true
    res = await fetch "/.netlify/functions/request-invitation", method: "GET"
    if res.ok
      Cookies.set "invitation_requested_at_#{github}", (new Date).toISOString(), expires: 7, path: '/'
      @setState requesting: false, requested: true
    else
      @setState requesting: false, requested: false, request_response: <p>There was a problem sending your request.<br/><br/>Please try again later.</p>
